import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormGroup } from '../FormGroup';

/**
 * A TextArea can be used to allow for extended user input.
 */
const TextArea = React.forwardRef((props, ref) => {
  const { children, className, label, id, error, ...otherProps } = props;
  const formGroupProps = { label, id, error };
  const inputProps = { id, ref, ...otherProps };
  const classNames = classnames('form-input', className);

  return (
    <FormGroup {...formGroupProps}>
      <textarea {...inputProps} className={classNames}>
        {children}
      </textarea>
    </FormGroup>
  );
});

TextArea.propTypes = {
  /** Primary content. */
  children: PropTypes.string,
  /** Additional classes. */
  className: PropTypes.string,
  /** Optional Label to display along side the TextArea. */
  label: PropTypes.string,
  /** Input id */
  id: PropTypes.string,
  /** Error message */
  error: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string])),
  ]),
};

TextArea.defaultProps = {
  className: '',
  label: '',
  id: '',
  children: '',
  error: '',
};

export { TextArea };
